<template>
  <div class="com disFlex fc">
    <img :src="item.pic" class="goods-img" />
    <div class="com-detail disFlex vertical Flex-between">
      <div class="goods-title clamp1">{{item.productName}}</div>
      <div class="goods-info disFlex Flex-center Flex-between">
        <div class="goods-price f fc">
          <div class="sale-price">￥{{item.seckillPrice}}</div>
          <div class="origin-price">￥{{item.salePrice}}</div>
        </div>
        <div class="goods-num">x{{item.num}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default:null,
    },
  },
};
</script>

<style lang="less" scoped>
.com {
  padding: 15px 0;
  .com-detail {
    width: 100%;

    height: 100px;
    float: 1;
  }
  .goods-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    margin-right: 11px;
  }
  .goods-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
  }
  .sale-price {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(0, 48, 120, 1);
  }
  .origin-price {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    text-decoration: line-through;
    color: rgba(105, 105, 105, 1);
  }
  .goods-num {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(53, 53, 53, 1);
  }
}
</style>